import React from 'react';
import cn from 'classnames';

import Button from '../../../common/ui/Button';
import Modal from '../../../common/ui/Modal';

import styles from './styles.module.scss';

const PolicyModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      preventClosing={true}
      isOpen={isOpen}
      hideCloseIcon
      className={styles.policyModal}
    >
      <h3 className={cn('h3', styles.title)}>Cancellation policy</h3>
      <ul className={styles.list}>
        <li>
          The no-refund rule if she's canceling outside the 7 calendar days upon
          device receipt.{' '}
        </li>
        <li>
          The requirement to cancel at least 5 business days before a new cycle
          to avoid charges.{' '}
        </li>
        <li>
          The non-refundable nature of service fees and device warranty
          charges.{' '}
        </li>
        <li>
          The necessity to ensure device return within 7 calendar days of
          receiving the return label email.{' '}
        </li>
        <li>
          Device Return Fees if device return isn’t initiated within 7 days of
          receiving return label.
        </li>
      </ul>
      <Button className={styles.button} onClick={onClose}>
        Got It
      </Button>
    </Modal>
  );
};
export default PolicyModal;
